const cmsSharedConstantsEn = {
  cmsErrorTitleEN: 'Please enter English title',
  cmsErrorTitleAR: 'Please enter Arabic title',
  cmsErrorContentEN: 'Please enter English content',
  cmsErrorContentAR: 'Please enter Arabic content',
  cmsErrorName: 'Please enter a name',
  cmsFormInputLanguage: 'Input Language',
  cmsFormEnglish: 'English',
  cmsFormArabic: 'Arabic',
  cmsFormBiLingual: 'English & Arabic',
  cmsFormTitleEn: 'English Title',
  cmsFormTitleAr: 'Arabic Title',
  cmsFormSaveButton: 'Save',
  cmsFormEditButton: 'Edit',
  cmsFormDeleteButton: 'Delete',
};

export default cmsSharedConstantsEn;
